<script>

import Logo from "@/components/Logo.vue";

export default {
    components: {Logo}
}

</script>
<template>
  <div class="about">
    <a href="/"><Logo/></a>
    <h1>{{ $t('terms_conditions.title_label') }}</h1>
  </div>
</template>

<style>

</style>
